import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import ReportService from '../../../Services/ReportService'
import DataGrid from '../../../Component/DataGrid/DataGrid';
import { TableColumn } from 'react-data-table-component';
import { formatLimit } from '../../../Component/config';

interface UserLimitHistory {
    pageCount: number;
    transactionLimitId: string;
    userId: string;
    hourlyLimit: string | null;
    dailyLimit: string | null;
    weeklyLimit: string | null;
    monthlyLimit: string | null;
    startDate: string;
    endDate: string;
    isSingleTransaction: boolean;
    userCategory: string;
    adminName: string;
    adminId: string;
    createdUTC: string;
    modifiedUTC: string;
}

interface Props {
    selectedUserId: string;
    onClose: () => void;
    open: boolean;
    accessToken: string;
    isCsvDownload: boolean
}

interface State {
    userLimitsList: UserLimitHistory[];
    currentRowsPerPage: number;
    currentPage: number;
    totalRows: number;
    searchText: string;
    selectedFilter: string;
    filterValue: string;
}

interface IuserLimitHistory {
    transactionLimitId: string;
    hourlyLimit: string | null;
    dailyLimit: string | null;
    weeklyLimit: string | null;
    monthlyLimit: string | null;
    startDate: string;
    endDate: string;
    isSingleTransaction: boolean;
    userCategory: string;
    adminName: string;
    adminId: string;
    createdUTC: string;
    modifiedUTC: string;
}

class LimitHistoryTable extends Component<Props, State> {
    private tableColumns: TableColumn<IuserLimitHistory>[] = [
        {
            name: 'Admin Name',
            selector: row => row.adminName,
            sortable: false,
            id: "adminName",
        },
        {
            name: 'User Category',
            selector: row => row.userCategory,
            sortable: false,
            id: "userCategory",

        },
        {
            name: 'Hourly Limit',
            selector: row => row.hourlyLimit ? formatLimit(row.hourlyLimit, "en-US", "USD", "$") : "",
            sortable: true,
            id: "hourlyLimit",
        },
        {
            name: 'Daily Limit',
            selector: row => row.dailyLimit ? formatLimit(row.dailyLimit, "en-US", "USD", "$") : "",
            sortable: true,
            id: "dailyLimit",
        },
        {
            name: 'Weekly Limit',
            selector: row => row.weeklyLimit ? formatLimit(row.weeklyLimit, "en-US", "USD", "$") : "",
            sortable: true,
            id: "weeklyLimit",
        },
        {
            name: 'Monthly Limit',
            selector: row => row.monthlyLimit ? formatLimit(row.monthlyLimit, "en-US", "USD", "$") : "",
            sortable: true,
            id: "monthlyLimit",
        },
        {
            name: 'StartDate',
            selector: row => new Date(row.startDate).toLocaleString(),
            sortable: true,
            id: "startDate",

        },
        {
            name: 'End Date',
            selector: row => new Date(row.endDate).toLocaleString(),
            sortable: true,
            id: "endDate",
        },
        {
            name: 'CreatedUTC',
            selector: row => new Date(row.createdUTC).toLocaleString(),
            sortable: true,
            id: "createdUTC",
        },
        {
            name: 'ModifiedUTC',
            selector: row => new Date(row.modifiedUTC).toLocaleString(),
            sortable: true,
            id: "modifiedUTC",
        },

    ];
    state: State = {
        userLimitsList: [],
        currentRowsPerPage: 10,
        currentPage: 1,
        totalRows: 100,
        searchText: "",
        selectedFilter: "",
        filterValue: "",
    };

    componentDidMount() {
        this.fetchLimitHistory();
    }

    fetchLimitHistory() {
        const { selectedUserId } = this.props;
        let pageIndex: number = (this.state.currentPage - 1);
        let pagination: any = {
            "pageNumber": pageIndex,
            "recordPerPage": this.state.currentRowsPerPage
        }

        if (this.state.searchText) {
            pagination["searchText"] = this.state.searchText
        }

        if (this.state.selectedFilter) {
            pagination[this.state.selectedFilter] = this.state.filterValue;
        }

        ReportService.getUserLimitHistory(this.props.accessToken, pagination, selectedUserId).then(tr => {
            if (tr.ok) {
                tr.json().then(resp => {
                    this.setState({
                        userLimitsList: resp.userLimitsList,
                        totalRows: resp.pageCount
                    })
                });
            }
        });
    }

    render() {
        const { open, onClose } = this.props;

        if (!open) return null;
        return (
            <Dialog
                open={open}
                onClose={() => onClose()}
                fullWidth={true}
                className="setting-popup"
                keepMounted
                maxWidth='lg'
            >
                <DialogContent className="subMenuModal">
                    <div className="body-sub-container table-container">
                        <DataGrid
                            title='Limit History'
                            onFilterChange={(selectedFilter: string, filterValue: string) => {
                                this.setState({
                                    selectedFilter,
                                    filterValue,
                                    currentPage: 1,
                                }, () => this.fetchLimitHistory())
                            }}
                            defaultSearch={this.state.searchText}
                            onSearch={(searchText_: string) => {
                                this.setState({
                                    searchText: searchText_,
                                    currentPage: 1
                                }, () => {
                                    this.fetchLimitHistory();
                                });
                            }}
                            columns={this.tableColumns}
                            data={this.state.userLimitsList}
                            onChangePage={(page: number, totalRows: number) => {
                                this.setState({
                                    currentPage: page
                                }, () => {
                                    this.fetchLimitHistory();
                                })
                            }}
                            onChangeRowsPerPage={(currentRowsPerPage_: number, currentPage_: number) => {
                                this.setState({
                                    currentRowsPerPage: currentRowsPerPage_,
                                    currentPage: currentPage_
                                }, () => {
                                    this.fetchLimitHistory();
                                })
                            }}
                            pagination
                            paginationTotalRows={this.state.totalRows}
                            exportCsv={this.props.isCsvDownload ? true : false}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default LimitHistoryTable;
